import { useMutation } from '@tanstack/react-query';

import { AllowedTimeFormSchemaValues } from 'src/features/allowedTimes/utils/formSchema';
import { AllowedTimes } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/memberships/membership-type/:membershipTypeId/allowed-times/';

interface DTO extends AllowedTimeFormSchemaValues {
    membershipTypeId: string;
    parkingId: string;
}
const mutationFn = ({ membershipTypeId, parkingId, ...data }: DTO): Promise<AllowedTimes> => {
    return axios.post(formatResourcePath(RESOURCE, { membershipTypeId, parkingId }), data);
};

type MutationFnType = typeof mutationFn;

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as CREATE_MEMBERSHIP_TYPE_ALLOWED_TIME_RESOURCE,
    useMutationHook as useCreateMembershipTypeAllowedTime,
};
